"use client";

import { SeriesModel } from "@api/models";
import { sessionStore } from "@lib/sessionStore";
import { formatTime, getWaitAndFreeRecoveryRate } from "@lib/utils";
import { useEffect, useState, useSyncExternalStore } from "react";

export function SeriesReadableInfoBottomWaitAndFreeBar({ seriesHash }: { seriesHash: string }) {
  const { sessionStatus } = useSyncExternalStore(
    sessionStore.subscribe,
    sessionStore.getSnapshot,
    sessionStore.getServerSnapshot,
  );
  const [seriesWaitOn, setSeriesWaitOn] = useState<number>();

  useEffect(() => {
    if (sessionStatus === "authenticated") {
      fetch(`/api/episodes?seriesHash=${seriesHash}&numEpisodes=1&episodeFrom=1`)
        .then((res) => res.json())
        .then((res) => {
          const series = res.series as SeriesModel;
          if (series && series.summary) {
            setSeriesWaitOn(series.summary.seriesWaitOn);
          }
        });
    }
  }, [sessionStatus]);

  const { waitAndFreeRecoveryRate, waitAndFreeRecoveryTime } =
    getWaitAndFreeRecoveryRate(seriesWaitOn);

  if (seriesWaitOn !== undefined) {
    return (
      <div className="series-readable-charge">
        <span
          className={
            "series-readable-charge-fill" +
            (waitAndFreeRecoveryRate === 100 ? " mode-full" : " mode-waiting")
          }
          style={{
            backgroundSize: waitAndFreeRecoveryRate + "% 100%,100% 100%",
          }}
        >
          {waitAndFreeRecoveryTime > 0 && <>あと{formatTime(waitAndFreeRecoveryTime)}</>}
          {waitAndFreeRecoveryTime === 0 && <>チャージ済</>}
        </span>
      </div>
    );
  } else {
    return <></>;
  }
}
